import { useEffect } from "react";

const usePageTitle = (title) => {
  useEffect(() => {
    document.title = `${title} | Learning Portal`;
  }, [title]);
};

export default usePageTitle;
